import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { signIn, signOut, fetchAuthSession, resetPassword } from "aws-amplify/auth";
import authApi from "./api";

let token = localStorage.getItem("ACCESS_TOKEN") || null;

const initialState = {
  isLoading: false,
  isAuthenticated: token ? true : false,
  token: token,
  error: null,
  resetPasswordError: null,
  resetPasswordEmail: null,
  resetPasswordCodeSend: false,
  userRole: null,
  userRoleLoading: false
};

export const logOut = createAsyncThunk("logout", async (values, thunk) => {
  try {
    const response = await signOut();
    return response;
  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const forgotPassword = createAsyncThunk("forgotPassword", async (values, thunk) => {
  try {

    const response = await authApi.checkUser(values);
    if (response.data.msg === "validated") {
      const res = await resetPassword({ username: values.email });
      const response = { res: res, email: values.email };
      return response;
    }
  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const getUserRole = createAsyncThunk("getUserRole", async (_, thunk) => {
  try {
    const response = await authApi.getUserRole();
    return response.data?.data?.AccountRoles?.[0];
  } catch (error) {
    return thunk.rejectWithValue(error.message);
  }
});

export const login = createAsyncThunk("login", async (values, thunk) => {
  try {
    const response = await signIn({
      username: values.email,
      password: values.password,
    });

    if (response) {
      const fetchSessionResult = await fetchAuthSession();
      return fetchSessionResult.tokens.idToken.toString();
    }

    return thunk.rejectWithValue("Login Failed");
  } catch (error) {
    return thunk.rejectWithValue(error.message);
  }
});

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder
      //login cases
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.token = action.payload;
        localStorage.setItem("ACCESS_TOKEN", action.payload);
        window.location.href = '/manage-employer';
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.token = "";
        state.error = action.payload;

      })
      // logout cases
      .addCase(logOut.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(logOut.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.token = "";
        localStorage.removeItem("ACCESS_TOKEN");
        window.location.href = '/login';
      })
      .addCase(logOut.rejected, (state) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.token = "";
      })

      // logout cases
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resetPasswordEmail = action.payload.email;
        const { nextStep } = action.payload.res;
        if(nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE"){
          state.resetPasswordCodeSend = true;          
        }
      })
      .addCase(forgotPassword.rejected, (state) => {
        state.isLoading = false;
        state.resetPasswordError = "Error in sending code. Please try again later.";
      })
      // getUserRole cases
      .addCase(getUserRole.pending, (state) => {
        state.userRoleLoading = true;
      })
      .addCase(getUserRole.fulfilled, (state, action) => {
        state.userRoleLoading = false;
        state.userRole = action.payload;
      })
      .addCase(getUserRole.rejected, (state, action) => {
        state.userRoleLoading = false;
        state.error = action.payload;
      });
  },
});

export const authState = (state) => {
  return { ...state.auth };
};
